export const dashboardURL = 'https://panel.loginprime.com/api/external/get-html';
